import * as React from 'react'
import { AssignmentFlowContainerProps } from './types'
import { $GridCollapseContainer } from './styles'
import { ApplicationActions } from './ApplicationActions'

export const AssignmentFlowContainer: React.FC<AssignmentFlowContainerProps> = ({
  isMobile,
  call,
  step,
  handleSelect,
  handleOpenAssign,
  selectedAssignment,
  assignments,
  onDeleteApplication,
  canAssign,
  canDeleteApplication,
  setLeadAssignment,
  assignmentPartition,
  canMakeLead,
  hasLead,
  handleDownloadClick,
  proposalId,
  documents,
  downloadConsolidated,
  loading,
}) => {

  return (
    isMobile ?
      null
      :
      <$GridCollapseContainer item xs={4} md={3}>
        <ApplicationActions
          call={call}
          step={step}
          handleSelect={handleSelect}
          handleOpenAssign={handleOpenAssign}
          selectedAssignment={selectedAssignment}
          assignments={assignments}
          onDeleteApplication={onDeleteApplication}
          canAssign={canAssign}
          canDeleteApplication={canDeleteApplication}
          setLeadAssignment={setLeadAssignment}
          assignmentPartition={assignmentPartition}
          canMakeLead={canMakeLead}
          hasLead={hasLead}
          handleDownloadClick={handleDownloadClick}
          proposalId={proposalId}
          documents={documents || []}
          downloadConsolidated={downloadConsolidated}
          loading={loading}
        />
      </$GridCollapseContainer>
  )
}
